const state = {
  state: {
    task:0,
    remind:0,
  },
}
export default{
  state,
}



// WEBPACK FOOTER //
// ./src/store/modules/employee.js